import { useEffect, useState } from "react";
import { listDoorTickets, listScannerEvents } from "../lib/api";
import type { OrganizerTicketSummary, ScannerEvent } from "../lib/types";
import type { WorkspaceNavigationAccess } from "../lib/workspace-navigation";
import WorkspaceSwitcher from "../components/WorkspaceSwitcher";
import { StatusBadge } from "../components/admin-ui";

interface DoorTicketListPageProps {
  navigate: (path: string) => void;
  workspaceNavigationAccess: WorkspaceNavigationAccess;
}

export default function DoorTicketListPage({ navigate, workspaceNavigationAccess }: DoorTicketListPageProps) {
  const [events, setEvents] = useState<ScannerEvent[]>([]);
  const [eventId, setEventId] = useState("");
  const [query, setQuery] = useState("");
  const [tickets, setTickets] = useState<OrganizerTicketSummary[]>([]);

  useEffect(() => {
    void listScannerEvents().then((items) => {
      setEvents(items);
      setEventId(items[0]?.id ?? "");
    });
  }, []);

  useEffect(() => {
    if (eventId) void listDoorTickets(eventId, query).then(setTickets);
  }, [eventId, query]);

  return (
    <section className="page dashboard-page door-ticket-list">
      <div className="page-title-row">
        <div>
          <div className="eyebrow">Door operations</div>
          <h1>Ticket List</h1>
        </div>
        <WorkspaceSwitcher path="/scanner/tickets" access={workspaceNavigationAccess} navigate={navigate} />
      </div>
      <div className="button-row">
        <button className="secondary-action" onClick={() => navigate(`/scanner${eventId ? `?eventId=${eventId}` : ""}`)}>
          Scanner
        </button>
      </div>
      <section className="panel">
        <label>
          Event
          <select value={eventId} onChange={(event) => setEventId(event.target.value)}>
            {events.map((event) => <option key={event.id} value={event.id}>{event.title}</option>)}
          </select>
        </label>
        <label>
          Search
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Name, email, ticket code" />
        </label>
        <div className="stack-list">
          {tickets.map((ticket) => (
            <article className="mini-card" key={ticket.id}>
              <strong>{ticket.buyerName ?? "Ticket holder"}</strong>
              <span>{ticket.buyerEmail}</span>
              <span>{ticket.ticketTierName ?? "Ticket"} &middot; {ticket.ticketCode}</span>
              <div className="pill-list">
                <StatusBadge label={ticket.status.replace(/_/g, " ")} tone={ticket.status === "valid" ? "success" : "warning"} />
                <StatusBadge label={ticket.checkedIn ? "Checked in" : "Not checked in"} tone={ticket.checkedIn ? "info" : "neutral"} />
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  );
}
